export const BG_CONTAINER_COLORS = [
  {
    name: 'transparent',
    label: 'Transparent',
    style: {
      '--background-color': 'transparent',
      '--theme-color': 'transparent',
      '--theme-foreground-color': 'var(--reudnitz-color)',
    },
  },
  {
    name: 'white',
    label: 'White',
    style: {
      '--background-color': 'var(--reudnitz-color-white)',
      '--theme-color': 'var(--reudnitz-color-white)',
      '--theme-foreground-color': '#000000',
    },
  },
  {
    name: 'lightgrey',
    label: 'Light Grey',
    style: {
      '--background-color': 'var(--reudnitz-color-lightgrey)',
      '--theme-color': 'var(--reudnitz-color-lightgrey)',
      '--theme-foreground-color': '#1f2933',
    },
  },
  {
    name: 'grey',
    label: 'Grey',
    style: {
      '--background-color': 'var(--reudnitz-color-grey)',
      '--theme-color': 'var(--reudnitz-color-grey)',
      '--theme-foreground-color': '#1f2933',
    },
  },
  {
    name: 'green',
    label: 'Green',
    style: {
      '--background-color': 'var(--reudnitz-color)',
      '--theme-color': 'var(--reudnitz-color)',
      '--theme-foreground-color': '#ffffff',
    },
  },

  {
    name: 'dark',
    label: 'Dark',
    style: {
      '--background-color': 'var(--reudnitz-color-dark)',
      '--theme-color': 'var(--reudnitz-color-dark)',
      '--theme-foreground-color': '#ffffff',
    },
  },
];

export const BG_COLUMN_COLORS = [
  'transparent',
  '#ffffff',  // white
  '#f3f4f6',  // light grey
  '#d9dde1',  // grey 
  '#005f2e',  // green
  '#1f2933',  // dark
];
